"use client";

import React from "react";
import { Button } from "../../../components/ui/button";
import {
  Compass,
  Sprout,
  Mountain,
  Lightbulb,
  Globe,
  Flame,
  ArrowRight,
} from "lucide-react";
import { useRouter } from "next/navigation";

const Page = () => {
  return (
    <div className="border-l-4 border-[#FFAE00] pl-6 mx-auto max-w-3xl px-4 my-8">
      <div className="flex items-center gap-3 mb-4">
        <Globe className="w-6 h-6 text-[#FFAE00]" />
        <h2 className="text-2xl sm:text-3xl text-[#FFAE00] font-medium font-bricolage">
          Cancellation Policy
        </h2>
      </div>

      <p className="text-lg leading-relaxed font-jakarta mb-4">
        At <strong>Outcome Outing</strong>, we understand that plans can change.
        Life happens, priorities shift, and flexibility matters.
      </p>

      <p className="text-lg leading-relaxed font-jakarta mb-4">
        If you need to cancel your trip, we’ve designed a policy that balances
        fairness for both our travelers and our team of planners, mentors, and
        partners who make every experience possible.
      </p>

      <ul className="list-disc list-inside text-lg font-jakarta space-y-3 pl-4 mb-4">
        <li>
          <strong>More than 30 days before departure:</strong> Full refund minus
          a nominal processing fee.
        </li>
        <li>
          <strong>15-30 days before departure:</strong> 50% refund of the total
          trip amount.
        </li>
        <li>
          <strong>Less than 15 days before departure:</strong> No refund
          possible, as bookings and arrangements are finalized.
        </li>
      </ul>

      <p className="text-lg leading-relaxed font-jakarta mb-4">
        In the rare event of trip cancellation from our side — due to unforeseen
        circumstances, safety concerns, or lack of minimum participants — a full
        refund will be processed promptly.
      </p>

      <p className="text-lg leading-relaxed font-jakarta">
        Our aim is to ensure that your decision to join an Outcome Outing journey
        remains smooth, transparent, and stress-free.
      </p>
    </div>
  );
};

export default Page;
